<script setup>

defineProps({
    theme: Object,
    name: String,
    icon: String,
    singularTheme: Boolean
})
</script>

<template>
    <div class="flex flex-col gap-2" style="width: 290px">
        <div class="border bg-blue-100 dark:bg-blue-900 rounded overflow-hidden relative px-5 py-2 dark:border-blue-700 border-blue-200">
            <div class="flex gap-3 items-center overflow-hidden relative mt-12 dark:text-white text-roori-blue text-lg">
                <i :class="icon"></i>
                <p>{{name}}</p>
            </div>
            <slot name="illustration"></slot>
            <div v-if="!singularTheme" class="text-xs absolute top-3 left-4 border dark:border-white dark:text-white text-roori-blue border-blue-500  rounded-full px-2">
                {{ theme.darkMode ? $t('forms.theme_mode_dark') : $t('forms.theme_mode_light') }}
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<style scoped lang="scss">

</style>
